import { takeEvery, put, call, all, fork } from "redux-saga/effects";

// Login Redux States
import {
  GET_SERVICE_LIST,
  POST_ADD_SERVICE,
  GET_AVAILABLE_SERVICES,
  POST_UPDATE_SERVICES,
  GET_SERVICE_ID,
  POST_DELETE_SERVICE,
  GET_ACTIVE_SERVICES,
  POST_TIME_ZONE,
} from "./actionTypes";
import {
  getServiceListSuccess,
  getServiceListFail,
  postServiceSuccess,
  postServiceFail,
  getAvailableServicesSuccess,
  getAvailableServicesFail,
  updateServiceSuccess,
  updateServiceFail,
  getServiceIdSuccess,
  getServiceIdFail,
  postDeleteServiceSuccess,
  postDeleteServiceFail,
  getServicesByStateActiveSuccess,
  getServicesByStateActiveFail,
  postTimeZoneSuccess,
  postTimeZoneFail,
} from "./actions";

import {
  getServices,
  postServiceList,
  getServiceData,
  updateServiceData,
  getServiceDataId,
  postDeleteService,
  getActiveServices,
  postUserTimezone,
} from "../../helpers/fakebackend_helper";
import showToast from "common/Notification";

function* Post_userTimeZone({ payload: data }) {
  try {
    const response = yield call(postUserTimezone, data);
    yield put(postTimeZoneSuccess(response));
    if (response.time_zone && response.status) {
      localStorage.setItem("timezone", JSON.stringify(response?.time_zone));
      showToast("success", "Time Zone", response.message);
    } else {
      showToast("info", "Time Zone", response.message);
    }
  } catch (error) {
    yield put(postTimeZoneFail(error));
    showToast("error", "Time Zone", error);
  }
}

function* Get_ActiveService({ payload: data }) {
  try {
    const response = yield call(getActiveServices, data);
    yield put(getServicesByStateActiveSuccess(response));
  } catch (error) {
    yield put(getServicesByStateActiveFail(error));
  }
}

function* Post_DeleteService({ payload: data }) {
  try {
    const response = yield call(postDeleteService, data);
    yield put(postDeleteServiceSuccess(response));
    showToast("success", "Service", "Service Deleted");
  } catch (error) {
    yield put(postDeleteServiceFail(error));
    showToast("error", "Service", error);
  }
}

function* Get_serviceId({ payload: data }) {
  try {
    const response = yield call(getServiceDataId, data);
    yield put(getServiceIdSuccess(response));
  } catch (error) {
    yield put(getServiceIdFail(error));
  }
}

function* Post_UpdateService({ payload: data }) {
  try {
    const response = yield call(updateServiceData, data);
    yield put(updateServiceSuccess(response));
    showToast("success", "Service", "Service Updated Successfully");
  } catch (error) {
    yield put(updateServiceFail(error));
    showToast("error", "Service", error);
  }
}

function* Get_serviceList({ payload: data }) {
  try {
    const response = yield call(getServices, data);
    yield put(getServiceListSuccess(response));
  } catch (error) {
    yield put(getServiceListFail(error));
  }
}

function* Post_serviceData({ payload: data }) {
  try {
    const response = yield call(postServiceList, data);
    yield put(postServiceSuccess(response));
    showToast("success", "Service", "Service Created Successfully");
  } catch (error) {
    yield put(postServiceFail(error));
    showToast("error", "Service", error);
  }
}

function* Get_AvailableService({ payload: data }) {
  try {
    const response = yield call(getServiceData, data);
    yield put(getAvailableServicesSuccess(response));
  } catch (error) {
    yield put(getAvailableServicesFail(error));
  }
}

export function* watchGet_serviceList() {
  yield takeEvery(GET_SERVICE_LIST, Get_serviceList);
  yield takeEvery(POST_ADD_SERVICE, Post_serviceData);
  yield takeEvery(GET_AVAILABLE_SERVICES, Get_AvailableService);
  yield takeEvery(POST_UPDATE_SERVICES, Post_UpdateService);
  yield takeEvery(GET_SERVICE_ID, Get_serviceId);
  yield takeEvery(POST_DELETE_SERVICE, Post_DeleteService);
  yield takeEvery(GET_ACTIVE_SERVICES, Get_ActiveService);
  yield takeEvery(POST_TIME_ZONE, Post_userTimeZone);
}

function* serviceListSaga() {
  yield all([fork(watchGet_serviceList)]);
}

export default serviceListSaga;
